import { useSelector } from "react-redux";
import { isEmpty } from "../../Util"
import { useTranslation } from "react-i18next";


const Error = ({renderer, message}) => {

    const error = useSelector((state) => state.Reducer.error)
    const isTransactionProcessing = useSelector((state) => state.Reducer.isTransactionProcessing)

    const { t } = useTranslation()

    return (
        (renderer || !isEmpty(error)) && 
        <div className="az-pay-error az-center"> 
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none"><rect width="64" height="64" fill="#FCE5EB" rx="32"/><path fill="#DC3149" fillRule="evenodd" d="m32.9282 31.9833 10.7403-10.815c.2652-.267.2652-.6676 0-.9346-.2652-.2671-.663-.2671-.9282 0L32 31.0487 21.2597 20.1001c-.2652-.1335-.7956-.1335-1.0608 0-.2652.1336-.1326.8012 0 1.0682l10.7403 10.815-10.7403 10.815c-.2652.2671-.2652.6676 0 .9347.1326.267.3978.267.5304.267s.3978 0 .5304-.1335L32 33.0515l10.7403 10.815c.1326.1335.2652.1335.5304.1335s.3978 0 .5304-.1335c.2652-.2671.2652-.6676 0-.9346L32.9282 31.9833Z" clipRule="evenodd"/></svg>
            <div className="mt-4 text-center error-message">{isTransactionProcessing ? message : t('app.transaction.expired.text')}</div>
        </div>
    );
}
export default Error;